import { addons } from "@storybook/manager-api";
import leyboldTheme from "./LeyboldTheme";

addons.setConfig({
  theme: leyboldTheme,
});

